const styles = {
  subtitle: {
    fontWeight: 600,
    fontSize: { xs: 14, md: 18 },
    mb: 2,
  },
  whiteCard: {
    borderRadius: 4,
    p: 2,
    backgroundColor: "white",
    mb: 2,
  },
};

export default styles;
